import React from 'react';
import ReactMarkdown from 'react-markdown/with-html';
import { makeStyles, Theme } from '@material-ui/core/styles';
import cx from 'clsx';

const useStyles = makeStyles((theme: Theme) => {
  const { h1, h2, h3, h4, h5, h6, body1 } = theme.typography;

  return {
    root: {
      '& img': {
        //More can done for image sizing but will require discussion
        maxHeight: '400px',
        width: 'auto'
      },
      '& h1': {
        ...h1
      },
      '& h2': {
        ...h2
      },
      '& h3': {
        ...h3
      },
      '& h4': {
        ...h4
      },
      '& h5': {
        ...h5
      },
      '& h6': {
        ...h6
      },
      '& p': {
        ...body1
      },
      '& table': {
        width: '100%',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'collapse'
      },
      '& thead': { display: 'table-header-group' },
      '& tbody': { display: 'table-row-group' },
      '& th': {
        ...body1,
        color: 'rgba(0, 0, 0, 0.87)',
        fontWeight: 500,
        display: 'table-cell',
        padding: theme.spacing(2),
        textAlign: 'left',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        verticalAlign: 'inherit'
      },
      '& tr': {
        color: 'inherit',
        display: 'table-row',
        outline: 0,
        verticalAlign: 'middle',
        borderSpacing: 0,
        borderCollapse: 'collapse'
      },
      '& td': {
        ...body1,
        color: 'rgba(0, 0, 0, 0.87)',
        display: 'table-cell',
        padding: theme.spacing(2),
        textAlign: 'left',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        verticalAlign: 'inherit'
      },
      '& ul': {
        position: 'relative'
      },
      '& ul ul': {
        position: 'relative'
      },
      '& li': {
        ...body1,
        width: '100%',
        display: 'list-item',
        position: 'relative',
        boxSizing: 'border-box',
        textAlign: 'left',
        alignItems: 'center',
        paddingTop: theme.spacing(1),
        justifyContent: 'flex-start',
        textDecoration: 'none'
      },

      '& hr': {
        border: 'none',
        height: '1px',
        margin: 0,
        flexShrink: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.12)'
      },
      '& a': {
        ...body1,
        color: theme.palette.secondary.main,
        textDecoration: 'underline',
        '&:hover': {
          textDecoration: 'underline'
        }
      }
    }
  };
});

const Markdown: React.FC<React.ComponentProps<typeof ReactMarkdown>> = ({
  source,
  className,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <ReactMarkdown
      className={cx(classes.root, className)}
      source={source}
      escapeHtml={false}
      {...rest}
    />
  );
};

export default Markdown;
